import axios from 'axios';

const client = axios.create({ baseURL: process.env.REACT_APP_SANDBOX_API });

export function saveExperiment(token, payload) {
    return client.post("/experiments", payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function getExperiments(token) {
    return client.get("/experiments", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function getExperimentDetails(token, idExperiment) {
    return client.get(`/experiments/${idExperiment}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function updateUserExperiment(token, idExperiment, userExperiment, payload) {
    return client.put(`/experiments/${idExperiment}/users/${userExperiment}`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function createUserExperiment(token, idExperiment, userExperiment, payload) {
    return client.post(`/experiments/${idExperiment}/users/${userExperiment}`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export function createSession(token) {
    return client.post(`/sessions`, null, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}
